// extracted by mini-css-extract-plugin
module.exports = {"declaration":"KnwxrbCoz2uZIS-DXffdGw==","footer":"yTGnvkDP6yhwIP0IKSpKwg=="};